import { Field, NumericInput, RadioGroup, TextOutput } from '../../../../Core';
import { FieldSet } from '../../../../Layout';
import { WorksheetEquipmentDropdown } from 'Components/Worksheets/Core';
import { useSelector } from 'react-redux';
import { IWorksheetComponent } from '../../../Core/types';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
import deepEquals from 'Lib/Object/deepEquals';
import { hasEmptyValue, hasNonEmptyValue } from 'Lib/Any';
import { PlateItem } from '../../types';

let EquipmentPlateFieldSetBase: React.FC<IWorksheetComponent & { visible?: boolean }> = ({
  createWorksheetSelector,
  visible = true,
}) => {
  const plate = useSelector(createWorksheetSelector!('Plate')) as PlateItem;
  const plateMass = useSelector(createWorksheetSelector!('Mass'), deepEquals);
  const plateDiameter = useSelector(createWorksheetSelector!('Diameter'), deepEquals);
  const plateMismatch = useSelector(createWorksheetSelector!('CalibrationImportMismatch')) as boolean;

  return (
    <FieldSet visible={visible}>
      <Field
        input={<WorksheetEquipmentDropdown />}
        equipmentType="plate"
        name="Plate"
        importedCalibration={{
          Mismatch: plateMismatch,
          Mass: plateMass,
          Diameter: plateDiameter,
        }}
        importModel={{ Id: plate?.Id }}
      />
      <Field input={<TextOutput />} name="Diameter" visible={hasNonEmptyValue(plate?.Diameter)} />
      <Field
        input={<RadioGroup />}
        name="Diameter"
        visible={hasEmptyValue(plate?.Diameter)}
        options={['300', '450', '600'].map((e) => ({ label: e, value: e }))}
        freeEntry={true}
        freeEntryLabel="Other"
        freeEntryInput={NumericInput}
      />
      <Field input={<TextOutput />} name="Area" />
      <Field input={hasNonEmptyValue(plate?.Mass) ? <TextOutput /> : <NumericInput />} name="Mass" />
    </FieldSet>
  );
};

const EquipmentPlateFieldSet = withInjectedProps(EquipmentPlateFieldSetBase);
export { EquipmentPlateFieldSet as EquipmentPlateSection };
export default EquipmentPlateFieldSet;
